import { HUImageDto, HUImageDtoSchema } from "@modules/dtos/imageDto"
import { UserDtoSchema } from "@modules/profile/profileDtos"
import { PublicProfileDto } from "@modules/profile/publicProfile/publicProfileDto"
import { z } from "zod"

export enum BoxStaffPermissions {
  // PLANNING
  SEE_TIMETABLES = "SEE_TIMETABLES",
  CREATE_ACTIVITY = "CREATE_ACTIVITY",
  MANAGE_SLOTS = "MANAGE_SLOTS",
  MANAGE_TYPICAL_WEEK = "MANAGE_TYPICAL_WEEK",
  // PROGRAMMING
  MANAGE_PROGRAMMING = "MANAGE_PROGRAMMING",
  // OFFER
  SEE_OFFERS = "SEE_OFFERS",
  CREATE_OFFER = "CREATE_OFFER",
  EDIT_OFFER = "EDIT_OFFER",
  DELETE_OFFER = "DELETE_OFFER",
  // MEMBERS
  SEE_MEMBERS = "SEE_MEMBERS",
  EDIT_MEMBER = "EDIT_MEMBER",
  EDIT_MEMBER_OFFER = "EDIT_MEMBER_OFFER",
  ARCHIVE_MEMBER = "ARCHIVE_MEMBER",
  SEE_TERMINATED = "SEE_TERMINATED",
  SEND_OFFER = "SEND_OFFER",
  SEE_STAFF = "SEE_STAFF",
  ADD_STAFF = "ADD_STAFF",
  CHANGE_ROLE_STAFF = "CHANGE_ROLE_STAFF",
  REMOVE_STAFF = "REMOVE_STAFF",
  // LEADS
  SEE_LEADS = "SEE_LEADS",
  MANAGE_LEAD = "MANAGE_LEAD",
  // FINANCIAL
  SEE_FINANCIAL = "SEE_FINANCIAL",
  // ADMIN
  SEE_GYM_INFORMATION = "SEE_GYM_INFORMATION",
  EDIT_GYM_INFORMATION = "EDIT_GYM_INFORMATION",
  DELETE_GYM = "DELETE_GYM",
  SEE_BANK_DETAILS = "SEE_BANK_DETAILS",
  EDIT_BANK_DETAILS = "EDIT_BANK_DETAILS",
}

export enum BoxStaffStatus {
  ACCEPTED = "ACCEPTED",
  PENDING = "PENDING",
  TERMINATED = "TERMINATED",
}

export enum BoxStaffActionRequest {
  ACCEPT = "ACCEPT",
  REFUSE = "REFUSE",
  QUIT = "QUIT",
}

export enum BoxStaffRole {
  OWNER = "OWNER",
  CO_OWNER = "CO_OWNER",
  HEAD_COACH = "HEAD_COACH",
  COACH = "COACH",
  FINANCIAL = "FINANCIAL",
}

export const BoxStaffLightDtoSchema = z.object({
  staffMemberId: z.string(),
  staffMemberRole: z.nativeEnum(BoxStaffRole),
  user: UserDtoSchema,
})

export const BoxStaffAddInputSchema = z.object({
  userId: z.string().nullish(),
  userEmail: z.string().email().nullish(),
  role: z.nativeEnum(BoxStaffRole),
})

export const BoxStaffDetailedUpadteInputSchema = z.object({
  internalNote: z.string().optional(),
  role: z.nativeEnum(BoxStaffRole).optional(),
})

export const BoxStaffItemDtoSchema = z.object({
  id: z.string(),
  userId: z.string(),
  boxId: z.string(),
  role: z.nativeEnum(BoxStaffRole),
  status: z.nativeEnum(BoxStaffStatus),
  firstname: z.string().nullish(),
  lastname: z.string().nullish(),
  email: z.string().email(),
  avatar: HUImageDtoSchema.nullish(),
  creationDate: z.string().datetime(),
  username: z.string(),
  internalNote: z.string().nullish(),
  archived: z.boolean(),
})

export type BoxStaffDetailedDto = {
  id: string
  userId: string
  boxId: string
  role: BoxStaffRole
  status: BoxStaffStatus
  firstname?: string
  lastname?: string
  email: string
  avatar?: HUImageDto
  creationDate: string
  username: string
  internalNote?: string
  archived: boolean
  publicProfile?: PublicProfileDto
}

export type BoxStaffAddInput = z.infer<typeof BoxStaffAddInputSchema>
export type BoxStaffDetailedUpadteInput = z.infer<typeof BoxStaffDetailedUpadteInputSchema>
export type BoxStaffItemDto = z.infer<typeof BoxStaffItemDtoSchema>
export type BoxStaffLightDto = z.infer<typeof BoxStaffLightDtoSchema>
